import * as THREE from 'three';
// The idle camera's slow sweep through the room, shared by the site camera (IdleKeyframe, LoadingKeyframe) and the
// loading screen's 3D drawing, so the drawing is seen through exactly the camera that keeps moving after it fades.
// idleClock.ms is the idle time already shown by the loading screen; the idle keyframe continues from there.
// The loading screen starts the sweep at IDLE_START_MS: a little before the view from the front left (about 20 s in)
// where the desk and the chair read best, side by side and large, so the drawing is built around that portrait.
export const IDLE_ORIGIN = new THREE.Vector3(-20000, 12000, 20000);
export const IDLE_FOCUS = new THREE.Vector3(0, -1000, 0);
export const IDLE_FOV = 35;
export const IDLE_START_MS = 14000;
export const idleClock = { ms: IDLE_START_MS };
export function idleCameraPosition(ms, target = new THREE.Vector3()) {
    // sweep from the open left side up to the window wall, never past it
    return target.set(Math.sin((ms + 19000) * 0.00008) * 14500 - 5500, Math.sin((ms + 1000) * 0.000004) * 4000 + IDLE_ORIGIN.y - 3000, IDLE_ORIGIN.z);
}
